import React from 'react';
import {Container, Row} from "react-bootstrap";
import style from "../Section.module.css";
import {NavLink} from "react-router-dom";

const Articles = (props) => {
    return (
        <div>
            <Container>
                <Row>
                    <h4 className={style.title}><i className="far fa-file-alt"></i> Статьи в PDF <sup>{props.count}</sup></h4>
                    <ul>
                        <NavLink to={'/статьи'}><li>По дате публикации</li></NavLink>
                        <NavLink to={'/авторы'}><li>По авторам</li></NavLink>
                        <NavLink to={'/журналы'}><li>По журналам</li></NavLink>
                    </ul>
                </Row>
            </Container>
        </div>
    )
}
export default Articles;